import { ReferralVerificationReason } from 'app/core/enums/referral-verification-reason.enum';

export const ReferralVerificationReasonShortNames = {
  [ReferralVerificationReason.prescriberReferral]: "Prescriber",
  [ReferralVerificationReason.prescriberOfficeReferral]: "Prescriber Office",
  [ReferralVerificationReason.specialityReferral]: "Specialty",
  [ReferralVerificationReason.other]: "Other"
};
